import { Connection } from 'shared/types/ObjectTypes';
import { baseUrlIsRequired } from 'routes/providerBaseUrl';
import { validateBaseUrl } from '../validateBaseUrl';
import {
  constructEarthRangerUrl,
  extractEarthRangerSiteName,
  isEarthRangerConnectionType,
} from '../earthRangerUrl';

type Translate = (key: any, options?: any) => string;

// The Connection's own fields as the form edits them: an EarthRanger record
// shows its site name rather than its full URL.
export const toFormValues = (record: Connection): Connection =>
  isEarthRangerConnectionType(record.type.name)
    ? { ...record, base_url: extractEarthRangerSiteName(record.base_url) }
    : record;

// The header: EarthRanger connections are recognised by their site, so it
// shows the full host (e.g. playground.pamdas.org).
export const connectionTitleFor = (record: Connection) => {
  const site = isEarthRangerConnectionType(record.type.name)
    ? extractEarthRangerSiteName(record.base_url)
    : '';
  return site ? `${site}.pamdas.org` : record.name;
};

// Field errors for the name and address; empty when the form can be saved.
export const connectionFormErrors = (
  connection: Connection,
  t: Translate,
): Record<string, string> => {
  const errors: Record<string, string> = {};
  const urlError = validateBaseUrl({
    value: connection.base_url,
    asSiteName: isEarthRangerConnectionType(connection.type.name),
    optional: !baseUrlIsRequired(connection.type.value),
    t,
  });
  if (urlError) errors.base_url = urlError;
  if (connection.name.length === 0) errors.name = t('Name is required.');
  return errors;
};

// The PATCH body for the Connection's own fields.
export const connectionPatch = (connection: Connection) => ({
  base_url: isEarthRangerConnectionType(connection.type.name)
    ? constructEarthRangerUrl(connection.base_url)
    : connection.base_url,
  enabled: connection.enabled,
  owner: connection.owner.id,
  name: connection.name,
});
